import {
  ExternalUser,
  ExternalUserSubUser,
  FormsBuilder,
  InternalUser,
  RoleAndPermission,
  Group,
  Employee,
  Customer,
  SampleName,
  SampleList,
  Method,
  Service,
  Equipment,
  CustomerOrder,
  Jobs,
  FormsList,
  MethodAdder,
  ReportBuilder,
  FormsView,
  ReportTemplates,
  TemplateDetails,
  Dashboard,
  ManageJob,
  MethodFormView,
  DataEntry,
  EquipmentRecords,
  Store,
  ExpiredItems,
  Reagentsandchemicals,
  ManageGroup,
  Report,
  Subscriber,
  SubscriptionPlan,
  AdminFormList,
  CMS,
  EmployeeFormList,
  PublicFromList,
  EmployeeDetails,
  IdentificationRulesPage,
  ManageRule,
  NonConformityReport,
  NonConformityTicketMainPage,
  Accommodation,
  Building,
  Rooms,
  ClientFormList,
  ClientDetails,
  Vendor,
  ChainOfCustody,
  VendorDetails,
  VendorFormList,
  ApprovalList,
  VendorCategory,
  VendorSubCategory,
  FormsListHistory,
  ReportHistory,
  Document,
  DocumentRecords,
  CustomReports,
  QualityManagment,
  SubQualityManagment,
  UserActivity,
  UserVersion,
  ListOfDocument,
  QASetting,
  CustomReport,
  ReportTemplateDetailsReadOnly,
  MasterNameList,
  ClientDocument,
  ClientDocumentList,
  WorksheetList,
  WorksheetBuilder,
  MethodPackages,
  MethodPackageAdder,
  SubscriberMethodPackageAdder,
  WorksheetVersion,
  MasterJobs,
  AdminUser,
  ManagmentReview,
  InternalAudit,
  ExternalAudit,
  Training,
  PlanTraining,
  ManageParticipants,
  IntraLaboratoryProgram,
  InterLaboratoryProgram,
  PTProgram,
  SiteSetting,
  GeneralInventory,
  Complains,
  ComplainsReview,
  Suggestion,
  SuggestionReview,
  CustomerSurvey,
  SurveyAnalysis,
  EmployeeEvaluation,
  VendorEvaluation,
  EquipmentEvaluation,
  ClientEvaluation,
  RecurringSurveyAnalysis,
  ProjectList,
  NewSampleNames,
  NewSampleManageTests,
  SuppliersManageCars,
  SupplierCars,
  ReportVersionHistory,
  DraftReportApproval,
  CertifiedReferenceMaterial,
  CalibrationDevices,
  CalibrationDevicesRecords,
  OrganizationProfileFormList,
  EquipmentFormList,
  SubSampleName,
  ProjectWorkOrderDetails,
  ProjectWorkOrderDocketList,
  ProjectWorkOrderDocketSampleDetails,
  ProjectWorkOrderDocketSampleTestDetails,
  ProjectWorkOrderDocketSampleSubSampleDetails,
  ProjectWorkOrderDocketSampleSubSampleJobDetails,
  LeadCustomerList,
  RequestList,
  LogList,
  QuotationList,
  ClientRequestList,
  PoList,
  QuotationApproval,
  LabVisitor,
} from "../Pages";
import { lazy } from "react";

const Analysis = lazy(() => import("../Pages/Analysis/Analysis"));
const WorkOrderReport = lazy(() => import("../Pages/Report/WorkOrderReport"));
const SampleReport = lazy(() =>
  import("../Pages/Report/SampleReportList/SampleList")
);
const SampleCategories = lazy(() =>
  import("../Pages/SampleCategories/SampleCategories")
);
const ProjectDetails = lazy(() => import("../Pages/ProjectDetails"));
const SampleReportViewJob = lazy(() =>
  import("../Pages/Report/SampleReportList/Component/SampleReportViewJob")
);
const Suppliers = lazy(() => import("../Pages/Suppliers/Suppliers"));
const Settings = lazy(() => import("../Pages/Settings/Settings"));
const SupplierStations = lazy(() =>
  import("../Pages/SupplierStations/SupplierStations")
);
const SupplierBatch = lazy(() =>
  import("../Pages/SupplierBatch/SupplierBatch")
);
const SuppliersManageStations = lazy(() =>
  import("../Pages/SuppliersManageStations/SuppliersManageStations")
);
const SuppliersManageStationPatch = lazy(() =>
  import("../Pages/SuppliersManageStationPatch/SuppliersManageStationPatch")
);
const MailSettings = lazy(() => import("../Pages/MailSettings/MailSettings"));
const SiteWorkReport = lazy(() =>
  import("../Pages/SiteWorkReport/SiteWorkReport")
);
const SiteWorkReportResult = lazy(() =>
  import("../Pages/SiteWorkReportResult/SiteWorkReportResult")
);
const SiteWorkSampleReceiving = lazy(() =>
  import("../Pages/SiteWorkSampleReceiving/SiteWorkSampleReceiving")
);
const RequestViewPage = lazy(() =>
  import("../Pages/Requests/RequestViewPage")
);
const POApproval = lazy(() => import("../Pages/POApproval"));

const mainComponents = [
  {
    path: "adminRegistration",
    component: <AdminUser />,
    alternativename: "adminRegistration",
  },
  { path: "dashboard", component: <Dashboard /> },
  {
    path: "approvallist",
    component: <ApprovalList />,
    alternativename: "Approval List",
  },
  {
    path: "chainofcustody",
    component: <ChainOfCustody />,
    alternativename: "Chain Of Custody",
  },
  {
    path: "mycustody",
    component: <ChainOfCustody />,
    alternativename: "My custody",
  },
  { path: "CMS/*", component: <CMS /> },
  {
    path: "certified-reference-material",
    component: <CertifiedReferenceMaterial />,
    alternativename: "certifiedReferenceMaterial",
  },
  {
    path: "calibration-devices",
    component: <CalibrationDevices />,
    alternativename: "calibrationDevices",
  },
  {
    path: "calibration-devices/:name",
    component: <CalibrationDevicesRecords />,
    alternativename: "calibrationDevices",
  },
  {
    path: "/customreports",
    component: <CustomReports />,
    alternativename: "Custom Reports",
  },
  {
    path: "sitesetting",
    component: <SiteSetting />,
    alternativename: "Organisation Profile",
  },
  {
    path: "mail-setting",
    component: <MailSettings />,
    alternativename: "mail-setting",
  },
  {
    path: "settings",
    component: <Settings />,
    alternativename: "setting",
  },
  {
    path: "accommodation",
    component: <Accommodation />,
    alternativename: "Building",
  },
  {
    path: "accommodation/:name",
    component: <Building />,
    alternativename: "Building",
  },
  {
    path: "rooms",
    component: <Rooms />,
    alternativename: "Rooms",
  },
  { path: "formbuilder", component: <FormsBuilder /> },
  {
    path: "externalusers",
    component: <ExternalUser />,
    alternativename: "External Users",
  },
  {
    path: "externalusers/sub-user/:id",
    component: <ExternalUserSubUser />,
    alternativename: "External Users Sub User",
  },
  {
    path: "internalusers",
    component: <InternalUser />,
    alternativename: "Internal Users",
  },
  {
    path: "rolesandpermissions",
    component: <RoleAndPermission />,
    alternativename: "Roles and Permissions",
  },
  { path: "groups", component: <Group /> },
  { path: "employees", component: <Employee />, alternativename: "Employees" },
  {
    path: "employees/:name",
    component: <EmployeeDetails />,
    alternativename: "Employees",
  },
  {
    path: "employeeevaluation",
    component: <EmployeeEvaluation />,
    alternativename: "Employee Evaluation",
  },
  {
    path: "publicformlist",
    component: <PublicFromList />,
    alternativename: "formslist",
  },
  {
    path: "publicformlist/:name",
    component: <FormsListHistory />,
    alternativename: "formslist",
  },
  {
    path: "employeeformlist",
    component: <EmployeeFormList />,
    alternativename: "formslist",
  },
  {
    path: "employeeformlist/:name",
    component: <FormsListHistory />,
    alternativename: "formslist",
  },
  {
    path: "organizationprofileformlist",
    component: <OrganizationProfileFormList />,
    alternativename: "formslist",
  },
  {
    path: "organizationprofileformlist/:name",
    component: <FormsListHistory />,
    alternativename: "formslist",
  },
  {
    path: "equipmentformlist",
    component: <EquipmentFormList />,
    alternativename: "formslist",
  },
  {
    path: "equipmentformlist/:name",
    component: <FormsListHistory />,
    alternativename: "formslist",
  },
  {
    path: "subscriber",
    component: <Subscriber />,
    alternativename: "subscriber",
  },
  {
    path: "subscriber/:name",
    component: <SubscriberMethodPackageAdder />,
    alternativename: "subscriber",
  },
  {
    path: "SubscriptionPlan",
    component: <SubscriptionPlan />,
    alternativename: "Subscription Plan",
  },
  { path: "clients", component: <Customer />, alternativename: "Clients" },
  {
    path: "customers",
    component: <LeadCustomerList />,
    alternativename: "customers",
  },
  {
    path: "requests",
    component: <RequestList />,
    alternativename: "requests",
  },
  {
    path: "quotation-approval",
    component: <QuotationApproval />,
    alternativename: "quotationApproval",
  },
  {
    path: "po-approval",
    component: <POApproval />,
    alternativename: "poApproval",
  },
  {
    path: "log",
    component: <LogList />,
    alternativename: "log",
  },
  {
    path: "quotation",
    component: <QuotationList />,
    alternativename: "quotation",
  },
  {
    path: "po",
    component: <PoList />,
    alternativename: "po"
  },
  {
    path: "requests/view/:id",
    component: <RequestViewPage />,
  },
  {
    path: 'lab-visitors',
    component: <LabVisitor />,
    alternativename: "lab-visitors"
  },

  {
    path: "clientevaluation",
    component: <ClientEvaluation />,
    alternativename: "Client Evaluation",
  },
  {
    path: "clients/:name",
    component: <ClientDetails />,
    alternativename: "Clients",
  },
  {
    path: "clientformlist",
    component: <ClientFormList />,
    alternativename: "formslist",
  },
  {
    path: "clientformlist/:name",
    component: <FormsListHistory />,
    alternativename: "formslist",
  },
  {
    path: "nonconformityreport",
    component: <NonConformityReport />,
    alternativename: "Non-Conformity Report",
  },
  {
    path: "nonconformityreport/:name",
    component: <NonConformityTicketMainPage />,
    alternativename: "Non-Conformity Report",
  },

  {
    path: "samplesname",
    component: <SampleName />,
    alternativename: "Sample Name",
  },
  {
    path: "samplesname/subsamplenames/:name",
    component: <SubSampleName />,
    alternativename: "Sample Name",
  },
  {
    path: "samplecategory",
    component: <SampleCategories />,
    alternativename: "sampleCategory",
  },
  {
    path: "samplesinventory",
    component: <SampleList />,
    alternativename: "Samples Inventory",
  },
  { path: "methods", component: <Method />, alternativename: "Lab Methods" },
  {
    path: "methodpackages",
    component: <MethodPackages />,
    alternativename: "Method Package",
  },
  {
    path: "methodpackages/:name",
    component: <MethodPackageAdder />,
    alternativename: "Method Package",
  },
  {
    path: "methods/:name",
    component: <MethodAdder />,
    alternativename: "Lab Methods",
  },
  {
    path: "methods/:name/view",
    component: <ReportTemplateDetailsReadOnly />,
    alternativename: "Lab Methods",
  },

  {
    path: "methods/formbuilder",
    component: <FormsBuilder />,
    alternativename: "Lab Methods",
  },
  {
    path: "masterlist",
    component: <MasterNameList />,
    alternativename: "Master Name List",
  },
  { path: "services", component: <Service />, alternativename: "Services" },
  {
    path: "equipments",
    component: <Equipment />,
    alternativename: "Equipment",
  },
  {
    path: "equipments/:name",
    component: <EquipmentRecords />,
    alternativename: "Equipment",
  },
  {
    path: "workorders",
    component: <CustomerOrder />,
    alternativename: "Work Orders",
  },
  {
    path: "worksheet",
    component: <WorksheetList />,
    alternativename: "worksheet",
  },
  {
    path: "worksheet/builder",
    component: <WorksheetBuilder />,
    alternativename: "worksheet",
  },
  {
    path: "worksheet/:name",
    component: <WorksheetVersion />,
    alternativename: "worksheet",
  },
  {
    path: "workorders/:id",
    component: <ManageJob />,
    alternativename: "Work Orders",
  },
  {
    path: "/joblist",
    component: <MasterJobs />,
    alternativename: "Job List",
  },
  { path: "jobs", component: <Jobs />, alternativename: "Job" },
  {
    path: "jobs/form",
    component: <MethodFormView />,
    alternativename: "Job",
  },

  { path: "formslist", component: <FormsList /> },
  {
    path: "formslist/:name",
    component: <FormsListHistory />,
    alternativename: "formslist",
  },
  {
    path: "adminformslist",
    component: <AdminFormList />,
    alternativename: "formslist",
  },
  {
    path: "adminformslist/:name",
    component: <FormsListHistory />,
    alternativename: "formslist",
  },
  {
    path: "methodadders",
    component: <MethodAdder />,
    alternativename: "labmethods",
  },
  {
    path: "report-builder",
    component: <ReportBuilder />,
    alternativename: "reportbuilder",
  },
  {
    path: "generalinventory",
    component: <GeneralInventory />,
    alternativename: "General Inventory",
  },
  { path: "reports", component: <Report />, alternativename: "Reports" },
  {
    path: "reports/version-history/:id",
    component: <ReportVersionHistory />,
    alternativename: "reports",
  },
  {
    path: "reportcustom",
    component: <CustomReport />,
    alternativename: "Reports",
  },
  {
    path: "workorderreport",
    component: <WorkOrderReport />,
    alternativename: "Work Orders",
  },
  {
    path: "samplereport",
    component: <SampleReport />,
    alternativename: "Samples Inventory",
  },
  {
    path: "samplereport/:id",
    component: <SampleReportViewJob />,
    alternativename: "Samples Inventory",
  },
  { path: "form", component: <FormsView />, alternativename: "formbuilder" },
  {
    path: "dataentries",
    alternativename: "Data Entery",
    component: <DataEntry />,
  },
  {
    path: "report-templates",
    component: <ReportTemplates />,
    alternativename: "Reports Templates",
  },
  {
    path: "report-templates/:id",
    component: <TemplateDetails />,
    alternativename: "Reports Templates",
  },
  {
    path: "report-templates/version",
    component: <ReportHistory />,
    alternativename: "Reports Templates",
  },
  {
    path: "report-templates/view",
    component: <ReportTemplateDetailsReadOnly />,
    alternativename: "Reports Templates",
  },
  {
    path: "report-templates/version/:name",
    component: <ReportTemplateDetailsReadOnly />,
    alternativename: "Reports Templates",
  },
  { path: "stores", component: <Store />, alternativename: "Store" },
  {
    path: "expireditems",
    component: <ExpiredItems />,
    alternativename: "Expired Items",
  },
  {
    path: "reagentsandchemicals",
    component: <Reagentsandchemicals />,
    alternativename: "Reagents And Chemicals",
  },
  {
    path: "groups/:name",
    component: <ManageGroup />,
    alternativename: "group",
  },
  {
    path: "identification",
    component: <IdentificationRulesPage />,
    alternativename: "identification-rules",
  },
  {
    path: "identification/:id",
    component: <ManageRule />,
    alternativename: "identification",
  },
  {
    path: "vendor",
    component: <Vendor />,
    alternativename: "Vendor",
  },
  {
    path: "vendorevaluation",
    component: <VendorEvaluation />,
    alternativename: "Vendor Evaluation",
  },
  {
    path: "categorymanagement",
    component: <VendorCategory />,
    alternativename: "Vendor Categories",
  },
  {
    path: "categorymanagement/:name",
    component: <VendorSubCategory />,
    alternativename: "Vendor Categories",
  },
  {
    path: "vendrformlist",
    component: <VendorFormList />,
    alternativename: "formslist",
  },
  {
    path: "vendrformlist/:name",
    component: <FormsListHistory />,
    alternativename: "formslist",
  },
  {
    path: "vendor/:name",
    component: <VendorDetails />,
    alternativename: "Vendor",
  },
  {
    path: "documents",
    component: <Document />,
    alternativename: "General Document" || "standarddocuments",
  },
  {
    path: "clientdocument",
    component: <ClientDocument />,
    alternativename: "Client Documents",
  },
  {
    path: "clientdocument/:name",
    component: <ClientDocumentList />,
    alternativename: "Client Documents",
  },
  {
    path: "clientrequests",
    component: <ClientRequestList />,
    alternativename: "Client Requests",
    // admin: 5,
  },
  //only for external user

  {
    path: "clientdocuments",
    component: <ClientDocumentList />,
    alternativename: "Client Documents",
  },
  {
    path: "documents/:name",
    component: <DocumentRecords />,
    alternativename: "General Document",
  },
  {
    path: "qualitymanagment",
    component: <QualityManagment />,
    alternativename: "Quality Managment",
  },
  {
    path: "qualitymanagment/:name",
    component: <SubQualityManagment />,
    alternativename: "Quality Managment",
  },
  {
    path: "qualitymanagment/:name",
    component: <SubQualityManagment />,
    alternativename: "Quality Managment",
  },
  {
    path: "qmsetting",
    component: <QASetting />,
    alternativename: "Quality Manual",
  },
  {
    path: "listofdocument/:name",
    component: <ListOfDocument />,
    alternativename: "qualitymanagment",
  },
  {
    path: "userActivity",
    component: <UserActivity />,
    alternativename: "userActivity",
  },
  {
    path: "userActivity/version",
    component: <UserVersion />,
    alternativename: "UserVersion",
  },
  {
    path: "managmentreview",
    component: <ManagmentReview />,
    alternativename: "Management Review",
  },
  {
    path: "internalaudit",
    component: <InternalAudit />,
    alternativename: "Internal Audit",
  },
  {
    path: "externalaudit",
    component: <ExternalAudit />,
    alternativename: "External Audit",
  },
  {
    path: "training",
    component: <Training />,
    alternativename: "Training",
  },
  {
    path: "plantraining",
    component: <PlanTraining />,
    alternativename: "Plan Training",
  },
  {
    path: "plantraining/:name",
    component: <ManageParticipants />,
    alternativename: "Plan Training",
  },
  {
    path: "intralaboratoryprogram",
    component: <IntraLaboratoryProgram />,
    alternativename: "Inter Laboratory Program",
  },
  {
    path: "interlaboratoryprogram",
    component: <InterLaboratoryProgram />,
    alternativename: "Inter Laboratory Program",
  },
  {
    path: "ptprogram",
    component: <PTProgram />,
    alternativename: "PT Program",
  },
  {
    path: "/complains",
    component: <Complains />,
    alternativename: "Complaints",
  },
  {
    path: "/complains/:id",
    component: <ComplainsReview />,
    alternativename: "Complaints",
  },
  {
    path: "suggestions",
    component: <Suggestion />,
    alternativename: "suggestion",
  },
  {
    path: "suggestions/:id",
    component: <SuggestionReview />,
    alternativename: "suggestion",
  },
  {
    path: "recurringsurveylist",
    component: <CustomerSurvey />,
    alternativename: "Recurring Survey List",
  },
  {
    path: "surveys",
    component: <SurveyAnalysis />,
    alternativename: "Surveys",
  },
  {
    path: "analysis",
    component: <Analysis />,
    alternativename: "Analysis",
  },
  {
    path: "recurringanalysis",
    component: <RecurringSurveyAnalysis />,
    alternativename: "Recurring Analysis",
  },
  {
    path: "equipmentevaluation",
    component: <EquipmentEvaluation />,
    alternativename: "Equipment Evaluation",
  },
  {
    path: "draft-report-approval",
    component: <DraftReportApproval />,
    alternativename: "Reports",
  },

  /* New requirement from client */
  {
    path: "projects",
    component: <ProjectList />,
    alternativename: "projects",
  },
  {
    path: "projects/:names",
    component: <ProjectDetails />,
  },
  {
    path: "projects/:names/:workorderNames/docket list",
    component: <ProjectWorkOrderDocketList />,
  },
  {
    path: "projects/:names/:workorderNames/:docketName/samples",
    component: <ProjectWorkOrderDocketSampleDetails />,
  },
  {
    path: "projects/:names/:workorderNames/:docketName/:sampleNames/sample-tests",
    component: <ProjectWorkOrderDocketSampleTestDetails />,
  },
  {
    path: "projects/:names/:workorderNames/:docketName/:sampleNames/sub samples",
    component: <ProjectWorkOrderDocketSampleSubSampleDetails />,
  },
  {
    path: "projects/:names/:workorderNames/:docketName/:sampleNames/:subSampleNames/jobs",
    component: <ProjectWorkOrderDocketSampleSubSampleJobDetails />,
  },
  {
    path: "projects/:names/:supplierNames",
    alternativename: "projectsuppliercarregister",
    component: <SuppliersManageCars />,
  },
  {
    path: "projects/:names/:supplierNames/manage-station",
    alternativename: "projectsupplierstationregister",
    component: <SuppliersManageStations />,
  },
  {
    path: "projects/:names/:supplierNames/:stationNames/manage-patch",
    alternativename: "projectsupplierstationpatchregister",
    component: <SuppliersManageStationPatch />,
  },
  {
    path: "samples-names",
    alternativename: "siteworksamplename",
    component: <NewSampleNames />,
  },
  {
    path: "samples-names/:names",
    alternativename: "siteworksamplename",
    component: <NewSampleManageTests />,
  },
  {
    path: "suppliers",
    alternativename: "suppliers",
    component: <Suppliers />,
  },
  {
    path: "suppliers/:names",
    alternativename: "suppliercarregister",
    component: <SupplierCars />,
  },
  {
    path: "suppliers/:names/station/",
    alternativename: "supplierstationregister",
    component: <SupplierStations />,
  },
  {
    path: "suppliers/:supplierNames/station/:names/batch/",
    alternativename: "supplierstationbatchregister",
    component: <SupplierBatch />,
  },
  {
    path: "site-work-report",
    alternativename: "site-work-report",
    component: <SiteWorkReport />,
  },
  {
    path: "site-work-report-result",
    alternativename: "site-work-report-result",
    component: <SiteWorkReportResult />,
  },
  {
    path: "sample-receiving",
    alternativename: "projectsamplereceiving",
    component: <SiteWorkSampleReceiving />,
  },
];

export default mainComponents;
